<script>
    import TemplateSlide from "../../Models/templateSlideModel";
    import Loader from "../Loader.svelte";

    import JSONTree from 'svelte-json-tree';
    import CodeEditor from "../Report/CodeEditor.svelte";
    import Assessment from "../../Models/assessmentModel";
    import { engine } from "../../lib/liquid_engine";

    import {notifier} from "@beyonk/svelte-notifications";
    import { handleError } from "../../Utilities/handlePromise";

    import {session, isAdmin} from '../../Utilities/Session.svelte';

    export let params;

    let name;
    let css;
    let body;
    let vars = [];

    let selected_option;
    let selected_assessment;
    let error_message = "";
    let slidePreview;

    let rendered_tpl;
    let rendered_css;

    let variables = {};

    const assessments = Assessment.getAssessmentList();

    function loadSlideData(slide) {
        if (slide == undefined) return;

        name = slide.details.name;
        css = slide.details.css || "\n\n\n";
        body = slide.details.body || "\n\n\n";

        vars = slide.details.vars || [];
        variables = slide.details.default_defs || {};
    }

    function saveSlide() {
        let details = $templateSlide.details;

        details.name = name;
        details.css = css;
        details.body = body;
        details.vars = vars;
        details.default_defs = variables;

        $templateSlide.save(details).then(() => {
            notifier.success("Slide Saved")
        }, handleError)
    }

    async function setSlideContent() {
        if (!(slidePreview && $selected_assessment)) return;

        // get variable assigns
        let assigns = '';
        for (let variable of vars) {
            assigns += `{% assign ${variable} = ${variables[variable]} %}`;
        }

        try {
            rendered_tpl = await engine.parseAndRender(assigns + body, {...$selected_assessment, slide_number: 1});

            rendered_css = await engine.parseAndRender(assigns + css, {...$selected_assessment, slide_number: 1});
        } catch (e) {
            error_message = e.message;
            return;
        }

        try {
            slidePreview.contentDocument.getElementsByTagName("body")[0].innerHTML = rendered_tpl;
            slidePreview.contentDocument.getElementById("custom_css").innerHTML = rendered_css;

            slidePreview.contentWindow.render(1);
        } catch (e) {
            console.log(e);
            console.info("Not Ready")
        }

        error_message = "";
    }

    async function selectAssessment() {
        if (!selected_option) return;

        let assessment_model = new Assessment(selected_option);
        selected_assessment = assessment_model.getAssessmentStore();

        setSlideContent()
    }

    function addVariable(evt) {
        let var_name = evt.target.variable_name.value;
        vars = [...vars, var_name];

        evt.target.reset()
    }

    function removeVariable(variable) {
        vars = vars.filter(v => v !== variable);

        delete variables[variable];
    }

    $: templateSlide = TemplateSlide.getStore(params.id);
    $: loadSlideData($templateSlide);

    $: selectAssessment(selected_option);
    $: setSlideContent(slidePreview, $selected_assessment, vars, variables, body, css);

    $: filtered_assessments = $assessments?.filter((a) => ($isAdmin || !a.users || a.users.includes($session.user.email)));
</script>

<Loader loading={!$templateSlide}>
    <div class="container is-fluid">
        <div class="buttons is-right">
            <a class="button" href="#/templateSlides">Close</a>
        </div>
        <div class="columns">
            <div class="column">
                <h1 class="title is-1">
                    <input type="text" class="input is-large" bind:value={name} />
                </h1>
            </div>
            <div class="buttons is-right column is-narrow flex">
                <button class="button is-success" on:click={saveSlide}>Save Slide</button>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="columns">
                    <div class="column is-4">
                        <h2 class="title is-2">HTML Template</h2>
                    </div>
                    <div class="column is-4">
                        <h2 class="title is-2">CSS Template</h2>
                    </div>
                    <div class="column is-4">
                        <h2 class="title is-2">Data</h2>
                    </div>
                </div>
                <div class="columns source">
                    <div class="column is-4">
                        <CodeEditor lang="liquid" bind:value={body} />
                    </div>
                    <div class="column is-4">
                        <CodeEditor lang="css" bind:value={css} />
                    </div>
                    <div class="column is-4" style="position:relative">
                        <Loader loading={!$assessments}>
                            <div class="select">
                                <select bind:value={selected_option}>
                                    {#each filtered_assessments as assessment}
                                        <option value={assessment}>{assessment.name}</option>
                                    {/each}
                                </select>
                            </div>
                        </Loader>
                        {#if $selected_assessment}
                            <JSONTree value={$selected_assessment}></JSONTree>
                        {:else}
                            <Loader fullscreen={false} />
                        {/if}
                    </div>
                </div>
                <div>
                    <div class="columns">
                        <div class="column">
                            <h2 class="title is-2">Variables</h2>
                            <ul class="variables">
                                {#each vars as variable}
                                    <li class="card">
                                        <span class="delete is-pulled-right" on:click={() => removeVariable(variable)}></span>
                                        <div class="variable_name">{variable}</div>
                                        <div>
                                            <input type="text" bind:value={variables[variable]} class="input">
                                        </div>
                                    </li>
                                {/each}
                            </ul>
                            <hr>
                            <form on:submit|preventDefault={addVariable}>
                                <div class="field is-horizontal">
                                    <div class="field-body">
                                        <div class="field has-addons">
                                            <div class="control is-expanded">
                                                <input class="input" type="text" name="variable_name" pattern="[a-zA-Z0-9_]+" required>
                                            </div>
                                            <button class="control button">Add Variable</button>
                                        </div>
                                    </div>
                                </div>
                                <p class="help">Can only contain letters, numbers and underscores</p>
                            </form>
                        </div>
                        <div class="column slide-column">
                            <div class="slide">
                                <iframe src="/slide_preview.html" bind:this={slidePreview} title="Slide Background" on:load={setSlideContent}></iframe>
                            </div>
                            <span class="has-text-error">{error_message}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Loader>

<style>
    .container {
        padding-top: 10px;
    }

    .flex {
        display: flex;
    }

    .source :global(.container) {
        padding: 0;
    }

    .slide-column {
        width: calc(13.333in + 19px);
    }

    .slide {
        border: 1px solid gray;
        height: 7.52in;
        width: calc(13.333in + 19px);
        position: relative;
        margin-top: 1em;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

    .source .column {
        height: 450px;
        overflow: auto;
    }

    .variables li {
        margin-top: 5px;
        padding: 10px;
    }

    .variable_name {
        font-weight: bold;
        margin-bottom: 3px;
    }
</style>